<template>
  <section id='Results' v-if='kirby.site.strings' :class='{phone : size == "phone"}'>
    <h3 class='heading'><span v-html='kirby.site.strings.resultsfound'>Results found:</span>&nbsp;<number class='tabular' :from="0" :to="resultnumber" :duration="0.5" easing="Power1.easeOut" /></h3>
    <nav class='pages'>
      <router-link :to='(result.uri != "home") ? "./"+result.uri : "/"' @click.native='$emit("resultClicked")' v-for='result in results' v-if='result.parent!="stories"'>
        <h3 v-html='result.content.title' />
      </router-link>
    </nav>
    <nav class='stories'>
      <router-link :to='result.uri' v-for='result in results' v-if='result.parent=="stories"' @click.native='$emit("resultClicked")'>
        <play :paused='true' />
        <header>
          <h3 v-html='result.content.title' />
          <summary v-html='result.content.text' />
        </header>
        <!--{{result.content.story_tags}}-->
      </router-link>
    </nav>
  </section>
</template>

<script>
import axios from 'axios';
import mixins from '.././mixins.js';

export default {
  mixins: [mixins], //kirby(), urltopath(), etc
  props: ['results'],
  computed: {
    resultnumber() {
      return Object.keys(this.results).length
    }
  }
}
</script>

<style>

#Results nav.stories a svg {
  width: 3rem;
  height: 3rem;
}

</style>



<style scoped>

  section {
    padding-top: 2em;
    flex-direction: column;
    padding-bottom: 1em;
  }

  nav {
    margin: 0;
    padding: 0;
  }

  h3.heading {
    margin-left: 10rem;
    margin-bottom: 1rem;
  }

  nav:empty {
    display: none;
  }

  nav.stories {
    width: 100%;
    border-top: var(--thinline);
    position: relative;
  }

  nav.stories::before {
    text-transform: uppercase;
    font-size: 1.2em;
    padding-top: 1.2em;
    position: absolute;
    content: 'Stories';
  }

  nav.stories a {
    display: flex;
    gap: 2rem;
    margin-left: 10rem;
    width: calc(100%-10rem);
    padding-top: 1rem;
    padding-bottom: 1rem;
    border-bottom: var(--thinline);
  }

  section.phone nav.stories a {
    margin-left: 6rem;
  }

  nav.pages:not(:empty) {
      border-top: var(--thinline);
      display: flex;
      flex-wrap: wrap;
      gap: 0.4em;
      margin-bottom: 2rem;
      padding-left: 10rem;
      width: calc(100%-10rem);
      position: relative;
      padding-top: 1rem;
  }

  nav.pages:not(:empty)::before {
    text-transform: uppercase;
    font-size: 1.2em;
    padding-top: 1.2em;
    position: absolute;
    top: 0;
    left: 0;
    content: 'Pages';
  }

  nav.pages a {
      padding: 0.3em;
      border-radius: 2em;
      display: inline-block;
      background-color: var(--mint);
      background-color: #cae6e5;
      font-size: 0.9rem;
      padding: 0.5em 1.5em;
      border-radius: 1em;
      line-height: 1em;
      cursor: pointer;
      user-select: none;
    }
</style>
